module.exports = __webpack_public_path__ + "img/location-gray.9573ee4e.svg";